import Contact, { ContactDto } from "../contact/models/contact"
import { Entity } from "../helpers/Entity"
import { InternalNoteDto, ProjectDto } from "../project/Project"
import { CalendarDto } from "./Calendar"

type CalendarEventAttributesDto = {
    status: string
    contact: ContactDto
    calendarId: string
    calendar: CalendarDto
    title: string
    location: string
    description: string
    startAt: string
    endAt: string
    invoiceId: string
    quoteId: string
    orderId: string
    contactId: string
    userId: string
    internalNotes: InternalNoteDto[]
    project: ProjectDto
}

export type CalendarEventDto = {
    id: string
    type: string
    attributes: CalendarEventAttributesDto
}

export default class CalendarEvent implements Entity {
    dto: CalendarEventDto
    contact: Contact

    constructor(dto: CalendarEventDto) {
        this.dto = dto
        this.contact = new Contact(dto.attributes.contact)
    }

    isLoaded() {
        return this.dto.id != ""
    }

    getId() {
        return this.dto.id
    }

    getLastInternalNote(): string {
        const internalNotes = this.dto.attributes.project.attributes.internalNotes
        const lastInternalNote = internalNotes.length > 0 ? internalNotes[internalNotes.length - 1].attributes.notes : ""
        return lastInternalNote
    }

    getCalendarLabel(): string {
        return this.dto.attributes.calendar ? this.dto.attributes.calendar.attributes.title : ""
    }

    getAttributes() {
        return this.dto.attributes
    }

    getStatus(): string {
        return this.dto.attributes.status
    }

    getCalendarId(): string {
        return this.dto.attributes.calendarId
    }

    getCalendar() {
        return this.dto.attributes.calendar
    }

    getTitle(): string {
        return this.dto.attributes.title
    }

    getLocation(): string {
        return this.dto.attributes.location
    }

    getDescription(): string {
        return this.dto.attributes.description
    }

    getStartAt() {
        return this.dto.attributes.startAt
    }

    getEndAt() {
        return this.dto.attributes.endAt
    }

    getInvoiceId() {
        return this.dto.attributes.invoiceId
    }

    getQuoteId() {
        return this.dto.attributes.quoteId
    }

    getOrderId() {
        return this.dto.attributes.orderId
    }

    getContactId(): string {
        return this.dto.attributes.contactId
    }

    getUserId(): string {
        return this.dto.attributes.userId
    }
}



// WEBPACK FOOTER //
// ./src/state/calendar-event/CalendarEvent.ts